import { ValidationConstants } from "../constants/validation.constants";

export class Validator {

  static Msisdn(msisdn: string) {
    return new RegExp(ValidationConstants.MsisdnRegex).test(msisdn);
  }

}